import { ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Dispatch, SetStateAction, useState } from 'react';

import { Button, Collapse } from '../../../../components/index';
import { isNullOrUndefined } from '../../../../utils/utils';
import { CargoSuppressionDrawer } from './CargoSuppressionDrawer';

const { Panel } = Collapse;

type FormItemsCargoSuppressionProps = {
  updatedAt?: string;
  openCollapsePanels: string | string[];
  setOpenCollapsePanels: Dispatch<SetStateAction<string | string[]>>;
  dockingCode?: string | null;
};

export function FormItemsCargoSuppression(
  props: FormItemsCargoSuppressionProps
) {
  const { updatedAt, openCollapsePanels, setOpenCollapsePanels, dockingCode } =
    props;
  const [isVisibleDrawer, setIsVisibleDrawer] = useState(false);

  function panelHeaderTitle() {
    return (
      <>
        Supressão de Carga
        {!isNullOrUndefined(updatedAt) && (
          <span
            className="header-description"
            style={{ float: 'right', fontWeight: 'normal', fontSize: '13px' }}
          >
            Atualizado em: {moment(updatedAt).format('DD/MM/YYYY HH:mm')}
          </span>
        )}
      </>
    );
  }

  const disabled = !dockingCode;

  return (
    <Collapse
      expandIconPosition="end"
      activeKey={openCollapsePanels}
      onChange={setOpenCollapsePanels}
    >
      <Panel forceRender header={panelHeaderTitle()} key="cargoSuppression">
        <CargoSuppressionDrawer
          visible={isVisibleDrawer && !disabled}
          onClose={() => setIsVisibleDrawer(false)}
          dockingCode={dockingCode || ''}
        />
        <Button
          type="primary"
          icon={<ExclamationCircleOutlined />}
          disabled={disabled}
          onClick={() => setIsVisibleDrawer(true)}
          style={{ marginBlockEnd: '10px' }}
        >
          Informar Supressão de Carga
        </Button>
        {disabled && (
          <span style={{ marginLeft: 12, color: '#888', fontSize: 13 }}>
            Salve a atracação antes de informar supressões.
          </span>
        )}
      </Panel>
    </Collapse>
  );
}
